/** @jsx $jsx */
import { $jsx } from 'framework7';
function framework7Component(props, {
  $,
  $el,
  $f7,
  $f7route,
  $f7router,
  $store,
  $update,
  $on
}) {
  let email = '';
  let password = '';
  let showPassword = false;
  let remember = false;
  let loading = false;
  const emailChanged = event => {
    email = event.target.value;
  };
  const passwordChanged = event => {
    password = event.target.value;
  };
  const rememberChanged = event => {
    remember = event.target.checked;
  };
  const togglePassword = () => {
    showPassword = !showPassword;
    $update();
  };
  const login = async event => {
    event.preventDefault();
    if (loading) {
      return;
    }
    email = email.trim().toLowerCase();
    if (!email || !password) {
      $f7.dialog.alert('कृपया ईमेल और पासवर्ड दर्ज करें।', 'लॉगिन');
      return;
    }
    loading = true;
    $update();
    try {
      const data = await $store.dispatch('loginUser', {
        email,
        password,
        remember
      });
      if (data && data.success) {
        $f7router.navigate($f7route.query.redirect || '/home/', {
          clearPreviousHistory: true,
          reloadCurrent: true
        });
      }
    } catch (error) {
      console.error('LOGIN ERROR:', error);
      $f7.dialog.alert(error.message || 'लॉगिन नहीं हो सका।', 'लॉगिन समस्या');
    } finally {
      loading = false;
      $update();
    }
  };
  $on('page:init', () => {
    console.log('LOGIN PAGE INITIALIZED');
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
    <div class="page login-page">

        <div class="login-content">

            <div class="login-brand">
                <div class="login-logo">
                    P
                </div>

                <div class="login-title">
                    पथक
                </div>

                <div class="login-subtitle">
                    गांव की प्रगति, सबकी भागीदारी
                </div>
            </div>

            <div class="login-card">

                <div class="login-heading">
                    स्वागत है
                </div>

                <div class="login-description">
                    अपने खाते में प्रवेश करें
                </div>

                <form name="login" action="#" method="POST" @submit=${login}>

                    <div class="login-field">

                        <i class="material-icons">
                            email
                        </i>

                        <input
                            type="email"
                            name="email"
                            placeholder="ईमेल पता"
                            autocomplete="username"
                            value=${email}
                            @input=${emailChanged}
                            required
                            autofocus
                        />

                    </div>

                    <div class="login-field">

                        <i class="material-icons">
                            lock
                        </i>

                        <input
                            type=${showPassword ? 'text' : 'password'}
                            name="password"
                            placeholder="पासवर्ड"
                            autocomplete="current-password"
                            value=${password}
                            @input=${passwordChanged}
                            required
                        />

                        <button
                            type="button"
                            class="password-toggle"
                            @click=${togglePassword}
                        >
                            <i class="material-icons">
                                ${showPassword
                                    ? 'visibility_off'
                                    : 'visibility'}
                            </i>
                        </button>

                    </div>

                    <div class="login-options">

                        <label class="login-remember">

                            <input
                                type="checkbox"
                                checked=${remember}
                                @change=${rememberChanged}
                            />

                            <span>
                                मुझे याद रखें
                            </span>

                        </label>

                        <a href="/forgot-password/">
                            पासवर्ड भूल गए?
                        </a>

                    </div>

                    <button
                        type="submit"
                        class="button button-fill login-button"
                        ?disabled=${loading}
                    >

                        ${loading
                            ? $h`
                                <span class="login-spinner"></span>
                                <span>लॉगिन हो रहा है...</span>
                              `
                            : $h`
                                <span>लॉगिन करें</span>
                              `
                        }

                    </button>

                </form>

                <div class="login-signup">

                    <span>
                        नया खाता बनाना चाहते हैं?
                    </span>

                    <a href="/signup/">
                        साइन अप करें
                    </a>

                </div>

            </div>

            <div class="login-footer">
                ग्राम प्रगति
            </div>

        </div>

    </div>
`
    }
    ;
}
framework7Component.id = 'd46199d846';
framework7Component.style = `
.login-page {
    background:
        linear-gradient(145deg,
            #fff8e9 0%,
            #fff3df 100%);
}

.login-content {
    width: 100%;
    height: 100%;
    min-height: 0;

    display: flex;
    flex-direction: column;
    align-items: center;

    box-sizing: border-box;

    padding:
        max(16px, env(safe-area-inset-top))
        16px
        max(16px, env(safe-area-inset-bottom));

    overflow: hidden;
}

.login-brand {
    display: flex;
    flex-direction: column;
    align-items: center;

    flex-shrink: 0;

    text-align: center;

    margin-bottom: 16px;
}

.login-logo {
    width: 52px;
    height: 52px;

    display: flex;
    align-items: center;
    justify-content: center;

    margin-bottom: 7px;

    border-radius: 14px;

    background:
        linear-gradient(145deg,
            #d94b05,
            #f28a24);

    color: #fff;

    box-shadow:
        0 5px 16px rgba(120, 50, 5, .16);

    font-size: 18px;
    font-weight: 800;

    letter-spacing: 1px;

    user-select: none;
}

.login-title {
    color: #28231f;

    font-size: 21px;
    font-weight: 800;

    line-height: 1.2;
}

.login-subtitle {
    margin-top: 3px;

    color: #858078;

    font-size: 11px;

    line-height: 1.35;
}

.login-card {
    width: 100%;
    max-width: 390px;

    box-sizing: border-box;

    padding: 18px 16px 16px;

    background: #fff;

    border: 1px solid #eadfd0;

    border-radius: 13px;

    box-shadow:
        0 4px 16px rgba(70, 40, 15, .08);

    max-height: calc(100% - 90px);

    overflow-x: hidden;
    overflow-y: auto;

    flex: 0 1 auto;

    scrollbar-width: thin;

    -webkit-overflow-scrolling: touch;
}

.login-card::-webkit-scrollbar {
    width: 5px;
}

.login-card::-webkit-scrollbar-track {
    background: transparent;
}

.login-card::-webkit-scrollbar-thumb {
    background: #d9cec1;

    border-radius: 10px;
}

.login-heading {
    color: #28231f;

    font-size: 19px;
    font-weight: 700;

    line-height: 1.3;

    text-align: center;
}

.login-description {
    margin-top: 4px;
    margin-bottom: 14px;

    color: #858078;

    font-size: 12px;

    line-height: 1.5;

    text-align: center;
}

.login-field {
    width: 100%;

    min-height: 43px;

    display: flex;
    align-items: center;

    box-sizing: border-box;

    padding: 0 10px;

    border: 1px solid #ded5ca;

    border-radius: 8px;

    background: #fff;

    transition:
        border-color .2s ease,
        box-shadow .2s ease,
        background-color .2s ease;

    margin-bottom: 9px;
}

.login-field:focus-within {
    border-color: #d94b05;

    background: #fffdf9;

    box-shadow:
        0 0 0 3px rgba(217, 75, 5, .09);
}

.login-field > .material-icons {
    width: 20px;

    margin-right: 8px;

    color: #817970;

    font-size: 19px;

    line-height: 1;

    flex-shrink: 0;
}

.login-field input {
    width: 100%;
    min-width: 0;

    height: 41px;

    margin: 0;
    padding: 0;

    border: 0;
    outline: 0;

    background: transparent;

    color: #28231f;

    font-family:
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        "Noto Sans Devanagari",
        sans-serif;

    font-size: 13px;

    line-height: normal;

    appearance: none;
}

.login-field input::placeholder {
    color: #9b938b;

    opacity: 1;
}

.login-field input:-webkit-autofill,
.login-field input:-webkit-autofill:hover,
.login-field input:-webkit-autofill:focus {
    -webkit-text-fill-color: #28231f;

    transition:
        background-color 9999s ease-out;
}

.password-toggle {
    width: 30px;
    height: 30px;

    display: flex;
    align-items: center;
    justify-content: center;

    flex-shrink: 0;

    margin: 0;
    padding: 0;

    border: 0;
    outline: 0;

    background: transparent;

    color: #817970;

    cursor: pointer;

    -webkit-tap-highlight-color: transparent;
}

.password-toggle:active {
    opacity: .65;
}

.password-toggle .material-icons {
    font-size: 18px;
}

.login-options {
    width: 100%;

    min-height: 20px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    gap: 10px;

    margin-top: 0;
    margin-bottom: 9px;

    font-size: 11px;
}

.login-remember {
    display: flex;
    align-items: center;

    gap: 5px;

    color: #625a53;

    white-space: nowrap;

    cursor: pointer;
}

.login-remember input {
    width: 13px;
    height: 13px;

    margin: 0;

    accent-color: #d94b05;
}

.login-options a,
.login-signup a {
    color: #d94b05;

    font-weight: 600;

    text-decoration: none;

    -webkit-tap-highlight-color: transparent;
}

.login-options a:active,
.login-signup a:active {
    opacity: .65;
}

.login-button {
    width: 100%;
    height: 43px;

    min-height: 43px;

    display: flex;
    align-items: center;
    justify-content: center;

    gap: 8px;

    margin-top: 2px;

    padding: 0 15px;

    border: 0;

    border-radius: 8px;

    background:
        linear-gradient(90deg,
            #d94b05,
            #e65d08);

    color: #fff;

    box-shadow:
        0 4px 10px rgba(217, 75, 5, .16);

    font-size: 13px;

    font-weight: 600;

    transition:
        transform .12s ease,
        opacity .2s ease,
        box-shadow .2s ease;

    -webkit-tap-highlight-color: transparent;
}

.login-button:active {
    transform: translateY(1px);

    box-shadow:
        0 2px 6px rgba(217, 75, 5, .14);
}

.login-button:disabled {
    opacity: .65;

    transform: none;

    box-shadow: none;
}

.login-spinner {
    width: 15px;
    height: 15px;

    box-sizing: border-box;

    border: 2px solid rgba(255, 255, 255, .40);

    border-top-color: #fff;

    border-radius: 50%;

    animation:
        login-spin .7s linear infinite;
}

@keyframes login-spin {
    to {
        transform: rotate(360deg);
    }
}

.login-signup {
    display: flex;
    align-items: center;
    justify-content: center;

    flex-wrap: wrap;

    gap: 4px;

    margin-top: 14px;

    color: #817970;

    font-size: 11px;

    line-height: 1.5;

    text-align: center;
}

.login-footer {
    margin-top: auto;

    padding-top: 12px;

    color: #aaa19a;

    font-size: 10px;

    line-height: 1.3;

    text-align: center;

    flex-shrink: 0;
}

@media (min-width: 600px) {
    .login-card {
        max-width: 410px;

        padding:
            20px 20px 18px;
    }
}

@media (max-height: 700px) {
    .login-content {
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .login-brand {
        margin-bottom: 10px;
    }

    .login-logo {
        width: 44px;
        height: 44px;

        margin-bottom: 4px;

        border-radius: 12px;

        font-size: 15px;
    }

    .login-title {
        font-size: 18px;
    }

    .login-subtitle {
        display: none;
    }

    .login-card {
        padding: 14px;
    }
}

@media (max-height: 560px) {
    .login-brand {
        display: none;
    }

    .login-card {
        max-height: 100%;
    }

    .login-footer {
        display: none;
    }
}

@media (max-width: 360px) {
    .login-content {
        padding-left: 10px;
        padding-right: 10px;
    }

    .login-card {
        padding-left: 13px;
        padding-right: 13px;
    }

    .login-options,
    .login-signup {
        font-size: 10px;
    }
}

@media (orientation: landscape) and (max-height: 500px) {
    .login-content {
        padding: 8px 14px;
    }

    .login-brand {
        display: none;
    }

    .login-card {
        max-width: 440px;

        max-height: 100%;

        padding: 13px 15px;
    }

    .login-footer {
        display: none;
    }
}

@media (prefers-reduced-motion: reduce) {
    .login-spinner {
        animation: none;
    }

    .login-button,
    .login-field {
        transition: none;
    }
}
`;
export default framework7Component;